import { getCurrentPeriodFromSelected } from './getCurrentPeriodFromSelected';

/**
 * Возвращает состояние посуточного размещения.
 *
 * @param {ISelectedTerm} объект выбранного типа размещения из placingTermsApi
 */
export const isDailySelected = (selected) => {
  const currentPeriod = getCurrentPeriodFromSelected(selected);

  if (!currentPeriod) {
    return false;
  }

  return ['dailyTermless', 'dailyLimited'].includes(currentPeriod.type);
};
